import React, { useState, useEffect, useCallback, useRef } from 'react'
import { Dropdown } from 'react-bootstrap';
import { useLocation, useParams } from 'react-router-dom';
import { DYNAMIC_TABLE, DYNAMIC_TABLE_ATTRIBUTE_LIST_BY_TABLE_ID_GET, GENERIC_DATA_ACTIVE, GENERIC_DATA_HARD_DELETE, GENERIC_DATA_IN_ACTIVE, GENERIC_PAGINATED, LIST, getApiPath } from "../../../api/ApiConst"
import apiCaller from "../../../api/ApiCaller";
import FilterScreen from '../../common/FilterScreen';
import TableRecordsList from './TableRecordsList';
import ViewRecordObjectData from './ViewRecordObjectData';
import { toast } from 'react-toastify';
import dateUtils from '../../common/utilities/DateUtilities';
import { isDeleteRecord } from '../../common/utilities/ConfirmationAlert';
import AddEditTableRecord from '../tableView/AddEditTableRecord'


var selectedHeaders = [];
var activeFilter = null;

const TableRecordsMaster = () => {
    const location = useLocation();
    const [tableDetailData, setTableDetailData] = useState();
    const tableDetailDataRef = useRef(location.state);
    const allTableListRef = useRef([]);
    const { viewTableName: tableId } = useParams();

    const [deleteAbleRowsData, setDeleteAbleRowsData] = useState([]);
    const [dynamicTableDrawCount, setDynamicTableDrawCount] = useState(0)
    const [selectedRow, setSelectedRow] = useState(null)
    const [genericUrlIs, setGenericUrlIs] = useState("");
    const [tableName, setTableName] = useState("");
    const [tableHeaderNames, setTableHeaderNames] = useState([]);
    const [allTableList, setAllTableList] = useState([]);
    const [sortTableData, setSortTableData] = useState({
        searchFilters: [],
        sortRules: []
    });
    const [showFilter, setShowFilter] = useState(false);
    const [columnData, setColumnData] = useState(null)
    const [dateTimeFilterArr, setDateTimeFilterArr] = useState({
        searchFilters: [],
        sortRules: []
    });
    const [filterScreenColumns, setFilterScreenColumns] = useState({
        columnName: "",
        show: false
    })
    const [tableColumns, setTableColumns] = useState([]);
    const [dynamicFormFields, setDynamicFormFields] = useState([]);
    const [showObjectModel, setShowObjectModel] = useState(false);
    const [activeModelRecordData, setActiveModelRecordData] = useState(null)
    const [showHideAddUpdateModel, setShowHideAddUpdateModel] = useState(false);

    // Update ref when tableDetailData changes
    useEffect(() => {
        tableDetailDataRef.current = tableDetailData;
    }, [tableDetailData]);

    useEffect(() => {
        if (tableDetailData) {
            setTableName(tableDetailData?.recordData?.name);
            let tableUrl = getApiPath(tableDetailData?.recordData?.pathValue, GENERIC_PAGINATED);
            
            setGenericUrlIs(tableUrl);
        } else {
            getAllDynamicTableList()
        }
        if (selectedHeaders.length !== 0) {
            setTableHeaderNames(selectedHeaders)
        }
    }, [tableDetailData]);

    useEffect(() => {
        // getAllDynamicTableList()
        setShowHideAddUpdateModel(false)
    }, [dynamicFormFields,tableId]);

    // get All Dynamic Table List
    const getAllDynamicTableList = () => {
        let allTableListUrl = getApiPath(DYNAMIC_TABLE, LIST);
        let tableRequestObj = {
            page: 0,
            size: 300,
            searchFilters: [],
            sortRules: []
        };
        apiCaller.callPostApi(allTableListUrl, tableRequestObj, {}, (response) => {
            let newTableDetailData = response?.data?.find(data => data.id === tableId)
            setTableDetailData({ recordData: newTableDetailData })
            allTableListRef.current = response.data;

            if(Array.isArray(response?.data)){
                setAllTableList(response?.data?.map((tableData, i) => ({ label: tableData.pathValue, value: tableData._id })));
            }
        }, (error) => {
            console.error("Error fetching table data:", error);
        });
    }

    useEffect(() => {
        if(allTableList.length > 0){
            getTableAttributeListForTableColumns()
        }
    }, [sortTableData, showFilter,allTableList])

    // Table Action Buttons
    const getDynamicTableActionButtons = useCallback(
        (row, i) => {
            return (
                <Dropdown className='custom-dropdown' key={i}>
                    <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                        <i className="fa fa-chevron-down"></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item
                            href={undefined}
                            onClick={() => {
                                setSelectedRow(row);
                                setShowHideAddUpdateModel(true);
                            }}
                        >
                            <i className="fa fa-edit me-2"></i> Edit
                        </Dropdown.Item>
                        <Dropdown.Item
                            href={undefined}
                            onClick={handleTableRecordDelete(row, false)}
                        ><i className="fa fa-trash me-2"></i> Delete</Dropdown.Item>
                        <Dropdown.Item
                            href={undefined}
                            onClick={handleTableRecordActive(row)}
                        ><i className="fa fa-circle-check me-2"></i> Active</Dropdown.Item>
                        <Dropdown.Item
                            href={undefined}
                            onClick={handleTableRecordInActive(row)}
                        ><i className="fa fa-circle-xmark me-2" ></i> InActive</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown >
            )
        },
        [dynamicTableDrawCount],
    );

    //Delete Record
    const handleTableRecordDelete = useCallback(
        (row, isMulti) => async () => {
            var deleteRecordData = []
            if (!isMulti) {
                deleteRecordData = [row._id];
            } else {
                if (row.length > 0) {
                    Array.isArray(row) && row.map((data) => {
                        deleteRecordData.push(data._id)
                    })
                }
            }

            if (deleteRecordData.length > 0) {
                let url = getApiPath(tableDetailDataRef.current?.recordData?.pathValue, GENERIC_DATA_HARD_DELETE);
                isDeleteRecord(url, refreshTable, deleteRecordData);
            }
        }, [] // Remove tableDetailData from dependencies since we're using ref
    );

    const handleTableRecordActive = useCallback(
        (row) => async () => {
            let url = getApiPath(tableDetailData?.recordData?.pathValue, GENERIC_DATA_ACTIVE);
            apiCaller.callPostApi(url, [row._id], {}, (response) => {
                toast.success("Success");
                refreshTable()
            }, (error) => {
                toast.error(error.response.data.message);
            });
        }, []
    );


    const handleTableRecordInActive = useCallback(
        (row) => async () => {
            let url = getApiPath(tableDetailData?.recordData?.pathValue, GENERIC_DATA_IN_ACTIVE);
            apiCaller.callPostApi(url, [row._id], {}, (response) => {
                toast.success("Success");
                refreshTable()
            }, (error) => {
                toast.error(error.response.data.message);
            });
        }, []
    );

    const _handleCollectionObjectData = (row, d) => {
        if(d?.referenceTable){
            let tableRequestObj = {
                page: 0,
                size: 100,
                searchFilters: [{
                    columnName: "id",
                    columnValue: d?.referenceTable,
                    operation: "EQUAL_TO"
                }],
                sortRules: []
            };
            apiCaller.callPostApi(getApiPath(DYNAMIC_TABLE, LIST), tableRequestObj, {}, (response) => {
                if(response?.data?.length > 0){
                    let referenceTable = response?.data?.[0]
                    let referenceTableNameAttribute = d?.name+"_"+referenceTable?.name
                    
                    let referenceTableData = {...(row?.[referenceTableNameAttribute] || {}), title: referenceTable?.name}

                    showModelBoxForObjectTypeData(referenceTableData)
                }
            }, (error) => {
                //    console.log(error);
            });
        }
        return;
    }


    // get table attribute List for Table columns Data
    const getTableAttributeListForTableColumns = useCallback(
        () => {
            var jsonRequest = {
                "page": 0,
                "size": 100,
                searchFilters: [],
                sortRules: [],
            };
            let attributesUrl = DYNAMIC_TABLE_ATTRIBUTE_LIST_BY_TABLE_ID_GET.replaceAll("{dynamic-table-id}", (tableDetailData?.recordData?._id || tableId))
            const options = [];
            const formOptions = [];
            const checkBoxData = [...tableHeaderNames];
            apiCaller.callPostApi(attributesUrl, jsonRequest, {}, (response) => {


                Array.isArray(response?.data) && response?.data?.map((d, i) => {
                    if (d.formAttribute) {
                        let tablePathIs = allTableList.find(obj => obj.value === d.referenceTable);
                        formOptions.push({
                            name: d.name,
                            formAttribute: d.formAttribute,
                            type: d.type,
                            referenceTable: d.referenceTable,
                            keyValuePair: { keyAttribute: d.keyAttribute, valueAttribute: d.valueAttribute },
                            referenceTablePath: (tablePathIs) ? tablePathIs?.label : null,
                            enumValues: d.enumValues
                        });
                    }
                    checkBoxData.push({
                        name: d.name,
                        type: d.type,
                        isChecked: (d.tableViewAttribute === true) ? true : false,
                        rowKey: i,
                    });
                })

                Array.isArray(response?.data) && response?.data?.map((d, i) => {
                    if (checkBoxData.some(data => data.name === d.name && data.isChecked)) {
                        options.push(
                            {
                                id: d.name,
                                name: <div className={`tableHeaders ${sortTableData.searchFilters.length !== 0 && (sortTableData.searchFilters.some((data) => data.columnName === d.name)) ? "active" : ""}`} key={i}>
                                    {/* name: <div className={`tableHeaders ${activeFilter != null && activeFilter.headerName == d.name ? "active" : ""}`} key={i}> */}
                                    <div className='custom-dropdown'>
                                        <div className='filter-screen'><i className='fa-solid fa-filter header-filter' onClick={() => handleSearchFilter(d.name, d.type)}></i>{(d.label !== null && d.label !== undefined) ? d.label : d.name}</div>
                                        {(filterScreenColumns.columnName === d.name && filterScreenColumns.show === true) &&
                                            <div className='custom-menu'>
                                                {columnData && callFilterScreen()}
                                            </div>
                                        }
                                    </div>

                                    <div div className="order" >

                                        <i className={`fa-solid fa-caret-up ${sortTableData.sortRules.length !== 0 && (sortTableData.sortRules.some((data) => data.columnName === d.name && data.operation === "ASC")) ? "active" : ""}`} onClick={() => handleAscDescSortRule(d.name, "ASC")}></i>
                                        <i className={`fa-solid fa-caret-down ${sortTableData.sortRules.length !== 0 && (sortTableData.sortRules.some((data) => data.columnName === d.name && data.operation === "DESC")) ? "active" : ""}`} onClick={() => handleAscDescSortRule(d.name, "DESC")}></i>
                                    </div >

                                </div >,
                                selector: (row, index) => <div className="ellipses">
                                    {
                                        d.type === "COLLECTION_OBJECT" ?


                                            (typeof row[d.name] === "object" || row[d.name] === null || row[d.name] === undefined)  ?
                                                row[d.name]?.title || row[d.name]?.name || "N/A"
                                                
                                                :
                                                <button className='show-modal-btn' onClick={() => _handleCollectionObjectData(row, d)}>
                                                    {
                                                        row[`${d.name}_${d.name?.replaceAll("ID","")}`]?.[0]?.name?.length > 0 ?
                                                            row[`${d.name}_${d.name?.replaceAll("ID","")}`]?.[0]?.name
                                                            :
                                                            row[`${d.name}_${d.name?.replaceAll("ID","")?.toLowerCase()}`]?.[0]?.name?.length > 0 ?
                                                            row[`${d.name}_${d.name?.replaceAll("ID","")?.toLowerCase()}`]?.[0]?.name
                                                            :
                                                            row[d.name] || "N/A"
                                                    }
                                                </button>


                                            :
                                            d.type === "COLLECTION_OBJECT_LIST" ?
                                                <div className='d-flex flex-wrap flex-column py-2 gap-1'>
                                                    {
                                                        Array.isArray(row?.[d.name]) ? row?.[d.name]?.map((item) => {
                                                            return <div><button className='show-modal-btn tag' onClick={() => _handleCollectionObjectData(row, d)}>{item.name}</button></div>
                                                        })
                                                        :null
                                                    }
                                                </div>
                                                :
                                                row[d.name] === undefined ?
                                                    "Not Found"

                                                    : row[d.name] === true ?
                                                        "Yes"

                                                        : row[d.name] === false ?
                                                            "No"

                                                            : typeof row[d.name] === "object" && row[d.name] !== null ?
                                                                <button className='show-modal-btn' onClick={() => showModelBoxForObjectTypeData(row[d.name])}>View Data</button>

                                                                : (d.type === "DATE" || d.type === "DATETIME") ?
                                                                    dateUtils.getFormattedDateTimeByTimeStamp(row[d.name])

                                                                    : row[d.name] || "N/A"}
                                </div>,
                                sortable: false,
                            },
                        );
                    }
                })
                if (options.length > 0) {
                    options.push(
                        {
                            id: "action",
                            name: "Action",
                            selector: (row, index) => getDynamicTableActionButtons(row, (options.length + 1)),
                            width: "100px",
                            sortable: false
                        }
                    )
                }
                setTableColumns(options)
                setDynamicFormFields(formOptions)
                setTableHeaderNames(checkBoxData)
                selectedHeaders = checkBoxData
            }, (error) => {
                console.error(error);
            })
        },
        [sortTableData, showFilter,allTableList],
    );

    // handle set Filter screen Columns
    const handleSearchFilter = (columnName, columnType) => {
        setShowFilter(prev => !prev);
        setFilterScreenColumns({
            columnName: columnName,
            show: true,
        })
        setColumnData([columnName, columnType])
    }

    // ============= Table Record Ascending/Descending ============== //
    const handleAscDescSortRule = (name, sortType) => {
        const _sortTableDataObj = [...sortTableData.sortRules];
        const found = _sortTableDataObj.some((data) => data.columnName === name)
        if (found) {
            const sortOperation = _sortTableDataObj.some((data) => ((data.operation === sortType) && (data.columnName === name)));
            if (sortOperation) {
                _sortTableDataObj.splice(_sortTableDataObj.findIndex((data) => data.columnName === name), 1);
            } else {
                _sortTableDataObj.splice(_sortTableDataObj.findIndex((data) => data.columnName === name), 1, {
                    columnName: name,
                    operation: sortType
                });
            }
        } else {
            _sortTableDataObj.push({
                columnName: name,
                operation: sortType
            });
        }

        setSortTableData({
            ...sortTableData, sortRules: _sortTableDataObj
        });
        setDateTimeFilterArr({
            ...dateTimeFilterArr, sortRules: _sortTableDataObj
        });
    }

    // ============= Add/Remove Table Column  ============== //
    const handleShowOrHideColumns = (event, name, type, checked, keyRow) => {
        event.stopPropagation();
        let _tableHeaderNames = [...tableHeaderNames];
        _tableHeaderNames.splice(_tableHeaderNames.findIndex(x => x.name === name), 1, {
            name: name,
            type: type,
            isChecked: !checked,
            rowKey: keyRow,
        });

        setTableHeaderNames(_tableHeaderNames)
        selectedHeaders = _tableHeaderNames;

        const _tableColumns = [...tableColumns];
        if (!checked) {
            // if(_tableColumns.)
            var actionIdKeyRow = _tableColumns.findIndex(x => x.id === "action");
            _tableColumns.splice((keyRow > actionIdKeyRow ? (actionIdKeyRow - 1) : keyRow), 0, {
                id: name,
                name: <div className={`tableHeaders ${activeFilter != null && activeFilter.headerName === name ? "active" : ""}`} key={keyRow}>
                    <i className="fa-solid fa-filter header-filter" onClick={() => handleSearchFilter(name, type)}></i> {name}
                    <div div className="order" >
                        <i className={`fa-solid fa-caret-up ${activeFilter != null && activeFilter.headerName === name && activeFilter.operation === "ASC" ? "active" : ""}`} onClick={() => handleAscDescSortRule(name, "ASC")}></i>
                        <i className={`fa-solid fa-caret-down ${activeFilter != null && activeFilter.headerName === name && activeFilter.operation === "DESC" ? "active" : ""}`} onClick={() => handleAscDescSortRule(name, "DESC")}></i>
                    </div >
                </div >,
                selector: (row, index) => <div className="ellipses">
                    {row[name] === undefined ? "Not Found" : row[name] === true ? "Yes" : row[name] === false ? "No" : typeof row[name] === "object" ? <button className='show-modal-btn' onClick={() => showModelBoxForObjectTypeData(row[name])}>View Data</button> : row[name]}
                </div>,
                sortable: false,
            },);
        } else {
            _tableColumns.splice(_tableColumns.findIndex(x => x.id === name), 1);
        }
        setTableColumns(_tableColumns);
    }

    // show Model Box for Object type data
    const showModelBoxForObjectTypeData = (data) => {
        setActiveModelRecordData(data);
        setShowObjectModel(true)
    }

    // Call Filter Screen 
    const callFilterScreen = () => {
        return (
            <FilterScreen dynamicFormFields={dynamicFormFields} sortTableData={sortTableData} columnData={columnData} sortTableDataIs={sortTableData} dateTimeFilterDataIs={dateTimeFilterArr} handleApplyFilter={handleApplyFilter} />
        )
    }

    // Apply Filter
    const handleApplyFilter = (searchFilterArr, name, isFilterApply, dateTimeFilterArrayData) => {
        if (isFilterApply) {
            if (Array.isArray(searchFilterArr) && searchFilterArr.length > 0) {
                let newSearchFilterArr = searchFilterArr.map((data) => {
                    if (data?.columnType === "ENUM") {
                        return { ...data, columnValue: data.operation, operation: "EQUAL_TO" }
                    } else {
                        return data;
                    }
                })
                const found = newSearchFilterArr.some((data) => (data.columnValue === "" || data.operation === ""));
                if (!found) {
                    setSortTableData({
                        ...sortTableData, searchFilters: [...newSearchFilterArr]
                    })
                    setColumnData(null)
                    activeFilter = {
                        headerName: name,
                    };
                    setFilterScreenColumns({
                        columnName: name,
                        show: false,
                    })
                    setDateTimeFilterArr({
                        ...dateTimeFilterArr, searchFilters: [...dateTimeFilterArrayData]
                    })
                }
            }
        } else {
            setSortTableData({
                ...sortTableData, searchFilters: [...searchFilterArr]
            })
            setColumnData(null)
            activeFilter = null;
            setFilterScreenColumns({
                columnName: "",
                show: true,
            })
            setDateTimeFilterArr({
                ...dateTimeFilterArr, searchFilters: [...dateTimeFilterArrayData]
            })
        }
    }

    // setting data for show-Hide Columns List 
    const tableColumnsHideShowSetting = useCallback(
        () => {
            return (
                <Dropdown className='filterColumn'>
                    <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                        <i className="fa-solid fa-gear"></i>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        {Array.isArray(tableHeaderNames) &&
                            tableHeaderNames.map((data, i) =>
                                <Dropdown.Item key={i} href={undefined} className="cursor-pointer"
                                    onClick={(e) => handleShowOrHideColumns(e, data.name, data.type, data.isChecked, data.rowKey)}
                                >
                                    <div className="custom-form-check form-check cursor-pointer"
                                    >
                                        <span className={`custom-checkBox ${data.isChecked && "checkedActive"}`}></span>
                                        <label className="form-check-label cursor-pointer">
                                            {data.name}
                                        </label>
                                    </div></Dropdown.Item>
                            )
                        }
                    </Dropdown.Menu>
                </Dropdown>
            )
        },
        [tableHeaderNames],
    );

    // Create Dynamic Form
    const handleCreateDynamicFrom = () => {
        if (dynamicFormFields.length > 0) {
            setShowHideAddUpdateModel(true);
        } else {
            toast.error("Table have not any Form Attribute.")
        }
    }

    // Show-Hide Object type Record Model Box
    const handleObjectRecordModel = () => {
        setShowObjectModel(pre => !pre);
    }

    // Show-Hide Model Box for New Record Create
    const handleRecordAddUpdateModel = () => {
        setShowHideAddUpdateModel(pre => !pre);
    }

    // Refresh Table Data
    const refreshTable = () => {
        setDynamicTableDrawCount(pre => pre + 1);
    }

    // Object Type Record View
    const viewObjectTypeRecordData = useCallback(
        () => {
            return (
                <ViewRecordObjectData title={activeModelRecordData?.title} showModel={showObjectModel} activeModelRecordData={activeModelRecordData}
                    close={handleObjectRecordModel} />
            )
        },
        [showObjectModel],
    );


    return (
        <>
            <div className="row justify-content-end">
                <div className="col-12 ">
                    <div className="d-flex justify-content-center" >
                        <h5>Table {tableName} Data</h5>
                    </div>
                </div>
                <div className="col-12">
                    <div className="card">
                        <div className="card-body d-flex justify-content-between">
                            <div className="d-flex justify-content-start" style={{ textAlign: "left" }}>
                                <button className="btn btn-primary mx-1" onClick={handleTableRecordDelete(deleteAbleRowsData, true)}>Delete</button>
                            </div>
                            <div className="d-flex justify-content-end" style={{ textAlign: "right" }}>
                                <button className="btn btn-primary mx-1" onClick={handleCreateDynamicFrom}>Add New</button>
                                {tableColumnsHideShowSetting()}
                            </div>
                        </div>
                        {/* <button className="btn btn-primary mx-1" onClick={handleCreateDynamicFrom}>Delete</button>
                        <div className="card-body d-flex justify-content-end" style={{ textAlign: "right" }}>
                            <button className="btn btn-primary mx-1" onClick={handleCreateDynamicFrom}>Add New</button>
                            {tableColumnsHideShowSetting()}
                        </div> */}
                        <TableRecordsList
                            genericUrlIs={genericUrlIs}
                            sortTableData={sortTableData}
                            tableColumns={tableColumns}
                            drawCount={dynamicTableDrawCount}
                            setDeleteAbleRowsData={setDeleteAbleRowsData}
                        />
                    </div>
                </div>
            </div>
            {viewObjectTypeRecordData()}
            {/* {tableRecordAddUpdate()} */}
            <AddEditTableRecord
                isOpen={showHideAddUpdateModel}
                tablePathValue={tableDetailData?.recordData?.pathValue}
                fields={dynamicFormFields}
                rowData={selectedRow}
                onClose={() => {
                    setShowHideAddUpdateModel(pre => !pre);
                    setSelectedRow(null)
                }}
                successCallBack={refreshTable}
                allTableList={allTableListRef.current}
            />
        </>
    )
}

export default TableRecordsMaster